/* GMapUtil */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define([], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.returnExports = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {
  var module = {};

  module.imageTagTrash = function() {
    return "<img src=\"" + require('images/trash.svg') + "\"/>";
  };

  module.imageTagMapLayer = function() {
    return "<img src=\"" + require('images/map_layer_icon.png') + "\"/>";
  };

  module.imageTagGear = function() {
    return "<img src=\"" + require('images/gear.png') + "\"/>";
  };

  module.imageTagRuler = function() {
    return "<img src=\"" + require('images/ruler.svg') + "\"/>";
  };

  module.imageUrlDot = function() {
    return require('images/dot.png');
  };

  module.imageStation = function() {
    return require('images/station.png');
  };

  module.imageStationDot = function() {
    return require('images/station_dot.png');
  };

  module.imageFacility = function(image_name) {
    return require('images/' + image_name);
  };

  module.generateMarkerImage = function (imageUrl, size) {
    return new google.maps.MarkerImage(
      imageUrl,
      new google.maps.Size(size, size),
      new google.maps.Point(0, 0),
      new google.maps.Point(size / 2, size / 2));
  };

  return module;
}));
